/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.home-carousel');

  if (carousel) {
    const updateSlideAccessibility = () => {
      const allSlides = carousel.querySelectorAll('.slick-slide');
      allSlides.forEach(slide => {
        slide.setAttribute('aria-hidden', 'true');
      });

      const activeSlides = carousel.querySelectorAll('.slick-slide.slick-active');
      activeSlides.forEach(activeSlide => {
        activeSlide.setAttribute('aria-hidden', 'false');
      });
    };

    // Warten, bis Slick geladen ist
    setTimeout(() => {
      updateSlideAccessibility();

      // Bei Slidewechsel erneut setzen
      $(carousel).on('afterChange', function () {
        updateSlideAccessibility();
      });
    }, 1000);
  }
});